export const getCategoryFilterInput = (filter: any): number => {
    switch (filter) {
        case "Required Topic Focus":
            return 1;
        case "Optional Topic Focus":
            return 2;
        case "Med School Admissions":
            return 3;
        default:
            return 1;
    }
}